import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleShipping() {
  const article = seoArticles.find((a) => a.slug === "wysylka-do-polski-z-chin-kakobuy")!;
  return <ArticleLayout article={article} />;
}